<template>
	<div class="cloudinary-component">
		<label class="b360-form-label" :for="`upload_widget-${id}`">{{
			label
		}}</label>
		<div class="cloudinary-wrapper">
			<div
				v-if="imageUri !== ''"
				:id="`cloudinary-thumbnail-${id}`"
				class="thumbnail"
				:style="`background-image: url(${imageUri})`"
			></div>

			<div v-else :id="`cloudinary-thumbnail-${id}`" class="thumbnail">
				<font-awesome-icon
					class="b360-form-icon"
					:icon="['fal', 'cloud-upload']"
				/>
				<span class="upload-description"
					>Click the button below to upload your photo</span
				>
			</div>

			<div class="button-wrapper">
				<cloudinary-widget
					:isLogo="isLogo"
					:disabled="disabled"
					@handle-upload="changeThumbnailImage"
					:id="id"
				></cloudinary-widget>
				<button
					:class="{ 'b360-btn--disabled': disabled }"
					:disabled="disabled"
					type="button"
					@click="deleteImage"
					:id="`delete-photo-${id}`"
					class="b360-btn--delete"
				>
					<font-awesome-icon :icon="['far', 'trash-alt']" />
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import CloudinaryWidget from '@/components/preference-center/CloudinaryWidget.vue';
import { faCloudUpload } from '@fortawesome/pro-light-svg-icons/faCloudUpload';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faTrashAlt, faCloudUpload);
Vue.component('font-awesome-icon', FontAwesomeIcon);
export default {
	name: 'CloudinaryUploader',
	components: {
		CloudinaryWidget,
	},
	props: {
		label: String,
		id: String,
		uri: String,
		disabled: Boolean,
	},
	data() {
		return {
			imageUri: '',
		};
	},
	computed: {
		isLogo() {
			return this.label.toUpperCase().includes('LOGO');
		},
	},
	methods: {
		changeThumbnailImage(response) {
			const regex = /\s/g;
			const { format } = response;
			const secureUrl = response.secure_url;
			const publicId = response.public_id.replace(regex, '').substring(0, 50);

			this.$emit('upload', { secureUrl, format, publicId });
		},
		deleteImage() {
			this.$emit('delete');
		},
	},
	mounted() {
		this.imageUri = this.uri;
	},
	watch: {
		uri(newValue) {
			this.imageUri = newValue;
		},
	},
};
</script>

<style scoped lang="scss">
.cloudinary-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-flow: row wrap;
}

.b360-btn {
	&--primary {
		width: 100%;
	}

	&--delete {
		@include rem('max-width', 45px);
	}
}

.button-wrapper {
	width: 100%;
	background-color: darken($off-white, 2.2%);
	border-radius: 0 0 5px 5px;
	border: 1px solid $border-color-light;
	display: flex;
	align-items: center;
	padding: 10px;

	button:first-of-type {
		margin-right: 10px;
	}
}

.b360-form-icon {
	@include rem('font-size', 50px);
	margin: auto auto 5px;
}

.thumbnail {
	@include rem('height', 320px);
	width: 100%;
	background-color: $white;
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	display: flex;
	justify-content: center;
	flex-flow: row wrap;
	align-items: center;
	border: 1px solid $border-color-light;
	border-bottom: none;
	text-align: center;
	border-radius: 5px 5px 0 0;

	.upload-description {
		width: 100%;
		margin: 5px auto auto;
	}
}
</style>
